import React, {useState} from 'react';
import Form, { Actions, Password, RequiredValidator } from '../../Components/Form';
import Card from '../../Components/Containers/Card';
import { Link, Navigate, useParams } from 'react-router-dom';
import { useToasts } from '../../Components/Toasts';
import API from '../../Services/API';

const ResetPassword = () => {
    const {hash} = useParams();
    const {showError, showSuccess} = useToasts();
    const [done, setDone] = useState(false);

    const reset = (data) => {
        if (data.newPassword !== data.confirmPassword) {
            showError('Your passwords do not match.');
            return;
        }

        data.hash = hash;

        return API.post('/auth/handleReset', data).then(result => {
            showSuccess('Your password has been reset, you can now login.');
            setDone(true);
        }).catch(err => {
            showError(API.parseErrorResponse(err))
        });
    }

    return <>
        <img src="/logo-name-horizontal.png"
            alt="getSoapy Logo"
            width="888"
            height="183"
            className="w-[75%] h-auto mx-auto mb-8"
        />

        <Card>
            {done && <Navigate to="/login" />}
            <Form onSubmit={reset}>
                <Password name="newPassword" label="New Password" validators={[RequiredValidator]} showPrompts />
                <Password name="confirmPassword" label="Confirm Password" validators={[RequiredValidator]} />
                <Actions submit={{label: 'Reset password'}}
                    left={<Link to="/login" className="inline-block mt-4 text-muted">Login</Link>}
                />
            </Form>
        </Card>

        <p className="text-center mt-4 text-muted text-sm">
            Don't have an account yet? <Link to="/register" className="link">Register for free!</Link>
        </p>
    </>;
}

export default ResetPassword;
